import { render } from "./addMatchSubject.vue?vue&type=template&id=788d3ffd&scoped=true"
import script from "./addMatchSubject.vue?vue&type=script&lang=js"
export * from "./addMatchSubject.vue?vue&type=script&lang=js"

import "./addMatchSubject.vue?vue&type=style&index=0&id=788d3ffd&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788d3ffd"]])

export default __exports__